export default {
  app: {
    payments: {
      currencies: ["EUR", "USD", "GBP"],
    },
  },
  notifications: {
    pollInterval: 30000,
  },
  vDataTable: {
    footerProps: {
      itemsPerPageOptions: [5, 10, 15, 50],
    },
  },
};
